export default __webpack_public_path__ + "static/p2-0c23e13ed336da3819737bd1bcf3f1c2.png";